<template>
  <div class="sale">
    <div class="sale-top">
      <div class="sale-top__title">
        销售提成设置
      </div>
      <div class="sale-top__right">
        店管员:
        <div class="sale-top__right--value">cb_970818825</div>
      </div>
    </div>
    <tips class="setting-tip">
      <div class="setting-tip__line">备注: 此处销售提成设置与店管员相关，如果没有提供销售提成，可不进行该项设置</div>
    </tips>
    <div class="sale-module">
      <div class="sale-module-list" v-for="(item, index) in storeList" :key="item.id">
        <div class="sale-module__name">店铺{{ index + 1 }}:{{ item.name }}</div>
        <div class="sale-module-list__input">
          <div class="sale-module-list__name">商品默认销售提成率(%):</div>
          <el-input size="mini" v-model="item.value" :disabled="item.isDisable"></el-input>
        </div>
        <div class="sale-module-list__fun">
          不同提成率的商品:
          <div class="sale-module-list__btn" @click="addBtnClick(index)">添加</div>
          <div class="sale-module-list__btn" v-show="item.isDisable" @click="changeBtnClick(index)">修改</div>
          <div class="sale-module-list__btn" v-show="!item.isDisable">保存</div>
        </div>
      </div>
    </div>
    <Dialog :show="dialogShow" @cancel="cancelDialog">
      <div class="sale-dialog">
        <div class="sale-dialog-top">
          <div class="sale-dialog__title">查找及选择不同提成率的商品</div>
          <div class="sale-dialog-top__right">
            <el-input size="mini" placeholder="请输入商品名称/型号/ASIN等" v-model="dialogSearchData"></el-input>
            <div class="sale-dialog__btn">搜索</div>
          </div>
        </div>
        <div class="sale-dialog-table">
          <Table
            :head="saleProductTableHead"
            :body="saleProductTableBody"
            width="744"
            @clickCheck="dialogCheckClick"></Table>
        </div>
        <div class="sale-dialog-bottom">
          <div class="sale-dialog__btn" @click="dialogAddBtnClick">添加</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import tips from '../common/tips.vue';
import { SaleCommission, SaleNewModule, SaleProductTableBody } from './class'
import UserAxios from 'service/user'
import Dialog from "components/common/Dialog.vue";
import Table from 'components/common/Table.vue'
import ProductAxios from 'service/product'
export default {
  name: 'salesCommissionSetting',
  components: { tips, Dialog, Table },
  data(){
    return {
      storeList: [],
      dialogShow: false,
      dialogSearchData: '',
      /**产品表头 */
      saleProductTableHead: SaleNewModule.NEWSALEPRODUCTTABLEHEAD(),
      /**产品列表 */
      saleProductTableBody: []
    }
  },
  async created(){
    let promiseArr = [
      UserAxios.getSaleCommissionConfig(),
      ProductAxios.getListingList({ asin: null, country: null, storeName: null })
    ]
    let resAll = await Promise.all(promiseArr)
    if(resAll[0].data.code !== 1){
      this.$message.error(resAll[0].data.info)
    }else{
      let arr = resAll[0].data.info
      this.storeList.splice(0, this.storeList.length)
      arr.map(object => {
        let obj = new SaleCommission(object.configId, object.storeName, object.defaultCommissionRate, object.productSaleCommission)
        this.storeList.push(obj)
      })
    }
    if(resAll[1].data.code === 1){
      let listingArray = resAll[1].data.info
      let listing
      this.saleProductTableBody.splice(0, this.saleProductTableBody.length)
      listingArray.map(object => {
        listing = new SaleProductTableBody()
        listing.backendListDataParsing(object)
        this.saleProductTableBody.push(listing)
      })
    }
  },
  methods:{
    /**修改按钮点击事件 */
    changeBtnClick(index){
      this.storeList[index].isDisable = false
    },
    /**添加按钮点击事件 */
    addBtnClick(index){
      this.changeBtnClick(index)
      this.dialogShow = true
      for(let i = 0; i < this.saleProductTableBody.length; i ++){
        this.saleProductTableBody[i].check = false
      }
    },
    /**关闭弹窗 */
    cancelDialog(){
      this.dialogShow = false
    },
    dialogCheckClick(index){
      this.saleProductTableBody[index].check = !this.saleProductTableBody[index].check
    },
    /**弹窗添加按钮点击事件 */
    dialogAddBtnClick(){
      console.log(this.saleProductTableBody);
    }
  }
}
</script>

<style lang="scss" scoped>
.sale{
  width: 1500px;
  min-height: 600px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 10px;
    &__title{
      display: flex;
      align-items: end;
      font-size: 16px;
      color: black;
      font-weight: bold;
    }
    &__tips{
      font-size: 12px;
      font-weight: normal;
      color: #fca605;
    }
    &__right{
      font-size: 12px;
      display: flex;
      color: #00a0c7;
      font-weight: bold;
      &--value{
        font-weight: normal;
      }
    }
  }
  &-module{
    &__name{
      color: #00a0c7;
      font-weight: bold;
      width: 200px;
    }
    &-list{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 10px 50px;
      padding: 50px 0;
      border-bottom: 1px solid #C0C4CC;
      &__name{
        width: 300px;
        text-align: end;
      }
      &__input{
        display: flex;
        align-items: center;
        ::v-deep{
          .el-input__inner{
            width: 100px;
          }
        }
      }
      &__fun{
        display: flex;
        align-items: center;
      }
      &__btn{
        background: #00a0c7;
        color: white;
        padding: 5px 20px;
        margin-left: 10px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
  }
  &-dialog{
    width: 800px;
    &-top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      &__right{
        display: flex;
        align-items: center;
        justify-content: right;
        width: 280px;
        ::v-deep{
          .el-input__inner{
            width: 200px;
          }
        }
      }
    }
    &__title{
      font-weight: bold;
      color: black;
    }
    &__btn{
      color: white;
      width: 100px;
      line-height: 30px;
      text-align: center;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
    &-table{
      margin: 10px 0;
    }
    &-bottom{
      display: flex;
      justify-content: end;
    }
  }
}
</style>
